import { ActionTypes } from '../../actions/constants';

export const initialState = {};

export default function facetsReducer(state = initialState, action = {}) {
    switch (action.type) {
        case ActionTypes.RESET_FILTERS:
            return initialState;

        case ActionTypes.CLEAR_FACET_OPTIONS: {
            return {
                ...state,
                [action.payload.facetId]: undefined,
            };
        }

        case ActionTypes.CLEAR_MANY_FACET_OPTIONS: {
            return {
                ...state,
                ...action.payload.facetIds.reduce((acc, facetId) => {
                    acc[facetId] = undefined;
                    return acc;
                }, {}),
            };
        }

        case ActionTypes.SELECT_FACET_OPTION: {
            const {
                facetId,
                optionId,
            } = action.payload;

            return {
                ...state,
                [facetId]: new Set([optionId]),
            };
        }

        case ActionTypes.CHECK_FACET_OPTION:
        case ActionTypes.UNCHECK_FACET_OPTION: {
            const {
                facetId,
                optionId,
            } = action.payload;

            const checkedOptions = new Set(state[facetId]);

            if (action.type === ActionTypes.CHECK_FACET_OPTION) {
                checkedOptions.add(optionId);
            } else {
                checkedOptions.delete(optionId);
            }

            return {
                ...state,
                [facetId]: checkedOptions,
            };
        }

        default:
            return state;
    }
}
